import _classCallCheck from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js";
// hacky debug.ts, can be replaced with a proper logging solution
// @ts-ignore
var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }
  _createClass(Logger, [{
    key: "debugLoggingEnabled",
    get: function get() {
      return window['SEGMENT_CONSENT_WRAPPER_DEBUG_MODE'] === true;
    }
  }, {
    key: "enableDebugLogging",
    value: function enableDebugLogging() {
      ;
      window['SEGMENT_CONSENT_WRAPPER_DEBUG_MODE'] = true;
    }
  }, {
    key: "debug",
    value: function debug() {
      if (this.debugLoggingEnabled) {
        var _console;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        (_console = console).log.apply(_console, ['[consent wrapper debug]'].concat(args));
      }
    }
  }]);
  return Logger;
}();
export var logger = new Logger();